import { pxToRem } from './biomeTokens';

export const textStyleTheme = {
  fontFamily: ['Roboto', 'normal'].join(','),
  h1: {
    fontSize: pxToRem(29.03),
    fontWeight: '600',
    lineHeight: pxToRem(34),
    letterSpacing: pxToRem(0)
  },
  h2: {
    fontSize: pxToRem(24.19),
    fontWeight: '600',
    lineHeight: pxToRem(28),
    letterSpacing: pxToRem(0)
  },
  h3: {
    fontSize: pxToRem(20.16),
    fontWeight: '600',
    lineHeight: pxToRem(24),
    letterSpacing: pxToRem(0)
  },
  h4: {
    fontSize: pxToRem(16.8),
    fontWeight: '600',
    lineHeight: pxToRem(20),
    letterSpacing: pxToRem(0)
  },
  'Subtitle 1': {
    fontSize: pxToRem(14),
    fontWeight: '700',
    lineHeight: pxToRem(16),
    letterSpacing: pxToRem(0)
  },
  'Subtitle 2': {
    fontSize: pxToRem(11.67),
    fontWeight: '700',
    lineHeight: pxToRem(14),
    letterSpacing: pxToRem(0)
  },
  'Body 1': {
    fontSize: pxToRem(14),
    fontWeight: '400',
    lineHeight: pxToRem(16),
    letterSpacing: pxToRem(0)
  },
  'Body 2': {
    fontSize: pxToRem(11.67),
    fontWeight: '400',
    lineHeight: pxToRem(14),
    letterSpacing: pxToRem(0)
  },
  'Caption 1': {
    fontSize: pxToRem(11.67),
    fontWeight: '700',
    lineHeight: pxToRem(14),
    letterSpacing: pxToRem(0)
  },
  'Caption 2': {
    fontSize: pxToRem(11.67),
    fontWeight: '400',
    lineHeight: pxToRem(14),
    letterSpacing: pxToRem(0)
  },
  'Overline 1': {
    fontSize: pxToRem(9.72),
    fontWeight: '600',
    lineHeight: pxToRem(12),
    letterSpacing: pxToRem(0)
  },
  'Overline 2': {
    fontSize: pxToRem(9.72),
    fontWeight: '400',
    lineHeight: pxToRem(12),
    letterSpacing: pxToRem(0)
  }
};
